var _path, _path2, _path3, _path4, _path5, _g, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _g2, _g3, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcon20(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 18,
    viewBox: "0 0 21 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.44315 5.29106C5.0112 5.93898 4.6966 6.82088 4.58789 7.15852L6.27537 8.37302L7.56403 6.74169C7.33422 6.39271 7.09414 6.0506 6.84411 5.71581C6.6406 5.46124 6.42434 5.21711 6.19618 4.98438L5.44315 5.29106V5.29106Z",
    fill: "url(#paint0_radial_3933_15437)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.44315 5.29106C5.0112 5.93898 4.6966 6.82088 4.58789 7.15852L6.27537 8.37302L7.56403 6.74169C7.33422 6.39271 7.09414 6.0506 6.84411 5.71581C6.6406 5.46124 6.42434 5.21711 6.19618 4.98438L5.44315 5.29106V5.29106Z",
    fill: "url(#paint1_radial_3933_15437)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5105 5.29106C15.9425 5.93898 16.2571 6.82088 16.3658 7.15852L14.6783 8.37302L13.3896 6.74169C13.5423 6.50772 13.9029 5.98578 14.1096 5.71581C14.3169 5.44584 14.6293 5.1154 14.7575 4.98438L15.5105 5.29106V5.29106Z",
    fill: "url(#paint2_radial_3933_15437)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5105 5.29106C15.9425 5.93898 16.2571 6.82088 16.3658 7.15852L14.6783 8.37302L13.3896 6.74169C13.5423 6.50772 13.9029 5.98578 14.1096 5.71581C14.3169 5.44584 14.6293 5.1154 14.7575 4.98438L15.5105 5.29106V5.29106Z",
    fill: "url(#paint3_radial_3933_15437)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5105 5.29106C15.9425 5.93898 16.2571 6.82088 16.3658 7.15852L14.6783 8.37302L13.3896 6.74169C13.5423 6.50772 13.9029 5.98578 14.1096 5.71581C14.3169 5.44584 14.6293 5.1154 14.7575 4.98438L15.5105 5.29106V5.29106Z",
    fill: "url(#paint4_radial_3933_15437)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_ii_3933_15437)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.20873 5.34397L3.44479 16.2572C3.49821 16.5172 3.63981 16.7508 3.84564 16.9185C4.05146 17.0861 4.30888 17.1775 4.57434 17.1772H16.381C16.6465 17.1773 16.9039 17.0856 17.1096 16.9177C17.3153 16.7498 17.4567 16.5159 17.5098 16.2557L19.7459 5.34325L19.0317 4.99481C17.9633 5.77088 15.7258 7.36261 15.1485 7.71105C14.6877 7.98894 14.2644 7.53611 14.1766 7.40725C13.3724 6.22659 12.145 4.50743 11.6857 3.90342C11.2163 3.28429 10.685 2.97904 10.4769 2.95312C10.2689 2.97904 9.73758 3.28429 9.26747 3.90342C8.80889 4.50743 7.58215 6.22659 6.77728 7.40725C6.68945 7.53611 6.26614 7.98966 5.80539 7.71105C5.22802 7.36261 2.99052 5.77088 1.92217 4.99481L1.20801 5.34325L1.20873 5.34397Z",
    fill: "url(#paint5_linear_3933_15437)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.20873 5.34397L3.44479 16.2572C3.49821 16.5172 3.63981 16.7508 3.84564 16.9185C4.05146 17.0861 4.30888 17.1775 4.57434 17.1772H16.381C16.6465 17.1773 16.9039 17.0856 17.1096 16.9177C17.3153 16.7498 17.4567 16.5159 17.5098 16.2557L19.7459 5.34325L19.0317 4.99481C17.9633 5.77088 15.7258 7.36261 15.1485 7.71105C14.6877 7.98894 14.2644 7.53611 14.1766 7.40725C13.3724 6.22659 12.145 4.50743 11.6857 3.90342C11.2163 3.28429 10.685 2.97904 10.4769 2.95312C10.2689 2.97904 9.73758 3.28429 9.26747 3.90342C8.80889 4.50743 7.58215 6.22659 6.77728 7.40725C6.68945 7.53611 6.26614 7.98966 5.80539 7.71105C5.22802 7.36261 2.99052 5.77088 1.92217 4.99481L1.20801 5.34325L1.20873 5.34397Z",
    fill: "url(#paint6_radial_3933_15437)"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M1.20873 5.34006L3.44479 16.2533C3.49821 16.5133 3.63981 16.7469 3.84564 16.9146C4.05146 17.0822 4.30888 17.1736 4.57434 17.1733H16.381C16.6465 17.1734 16.9039 17.0817 17.1096 16.9138C17.3153 16.7458 17.4567 16.512 17.5098 16.2518L19.7459 5.33934L19.0317 4.9909C17.9633 5.76697 15.7258 7.35871 15.1485 7.70715C14.6877 7.98503 14.2644 7.53221 14.1766 7.40334C13.3724 6.22268 12.145 4.50352 11.6857 3.89951C11.2163 3.28038 10.685 2.97514 10.4769 2.94922C10.2689 2.97514 9.73758 3.28038 9.26747 3.89951C8.80889 4.50352 7.58215 6.22268 6.77728 7.40334C6.68945 7.53221 6.26614 7.98575 5.80539 7.70715C5.22802 7.35871 2.99052 5.76697 1.92217 4.9909L1.20801 5.33934L1.20873 5.34006Z",
    fill: "url(#paint7_linear_3933_15437)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M1.20873 5.34006L3.44479 16.2533C3.49821 16.5133 3.63981 16.7469 3.84564 16.9146C4.05146 17.0822 4.30888 17.1736 4.57434 17.1733H16.381C16.6465 17.1734 16.9039 17.0817 17.1096 16.9138C17.3153 16.7458 17.4567 16.512 17.5098 16.2518L19.7459 5.33934L19.0317 4.9909C17.9633 5.76697 15.7258 7.35871 15.1485 7.70715C14.6877 7.98503 14.2644 7.53221 14.1766 7.40334C13.3724 6.22268 12.145 4.50352 11.6857 3.89951C11.2163 3.28038 10.685 2.97514 10.4769 2.94922C10.2689 2.97514 9.73758 3.28038 9.26747 3.89951C8.80889 4.50352 7.58215 6.22268 6.77728 7.40334C6.68945 7.53221 6.26614 7.98575 5.80539 7.70715C5.22802 7.35871 2.99052 5.76697 1.92217 4.9909L1.20801 5.33934L1.20873 5.34006Z",
    fill: "url(#paint8_linear_3933_15437)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M1.20873 5.34006L3.44479 14.8134C3.49821 15.0735 3.63981 15.3071 3.84564 15.4747C4.05146 15.6424 4.30888 15.7338 4.57434 15.7335H16.381C16.6465 15.7336 16.9039 15.6419 17.1096 15.4739C17.3153 15.306 17.4567 15.0722 17.5098 14.812L19.7459 5.33934L19.0317 4.9909C17.9633 5.76697 15.7258 7.35871 15.1485 7.70715C14.6877 7.98503 14.2644 7.53221 14.1766 7.40334C13.3724 6.22268 12.145 4.50352 11.6857 3.89951C11.2163 3.28038 10.685 2.97514 10.4769 2.94922C10.2689 2.97514 9.73758 3.28038 9.26747 3.89951C8.80889 4.50352 7.58215 6.22268 6.77728 7.40334C6.68945 7.53221 6.26614 7.98575 5.80539 7.70715C5.22802 7.35871 2.99052 5.76697 1.92217 4.9909L1.20801 5.33934L1.20873 5.34006Z",
    fill: "url(#paint9_linear_3933_15437)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M1.20873 5.34006L3.44479 14.8134C3.49821 15.0735 3.63981 15.3071 3.84564 15.4747C4.05146 15.6424 4.30888 15.7338 4.57434 15.7335H16.381C16.6465 15.7336 16.9039 15.6419 17.1096 15.4739C17.3153 15.306 17.4567 15.0722 17.5098 14.812L19.7459 5.33934L19.0317 4.9909C17.9633 5.76697 15.7258 7.35871 15.1485 7.70715C14.6877 7.98503 14.2644 7.53221 14.1766 7.40334C13.3724 6.22268 12.145 4.50352 11.6857 3.89951C11.2163 3.28038 10.685 2.97514 10.4769 2.94922C10.2689 2.97514 9.73758 3.28038 9.26747 3.89951C8.80889 4.50352 7.58215 6.22268 6.77728 7.40334C6.68945 7.53221 6.26614 7.98575 5.80539 7.70715C5.22802 7.35871 2.99052 5.76697 1.92217 4.9909L1.20801 5.33934L1.20873 5.34006Z",
    fill: "url(#paint10_radial_3933_15437)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M1.20873 5.34006L3.44479 16.2533C3.49821 16.5133 3.63981 16.7469 3.84564 16.9146C4.05146 17.0822 4.30888 17.1736 4.57434 17.1733H16.381C16.6465 17.1734 16.9039 17.0817 17.1096 16.9138C17.3153 16.7458 17.4567 16.512 17.5098 16.2518L19.7459 5.33934L19.0317 4.9909C17.9633 5.76697 15.7258 7.35871 15.1485 7.70715C14.6877 7.98503 14.2644 7.53221 14.1766 7.40334C13.3724 6.22268 12.145 4.50352 11.6857 3.89951C11.2163 3.28038 10.685 2.97514 10.4769 2.94922C10.2689 2.97514 9.73758 3.28038 9.26747 3.89951C8.80889 4.50352 7.58215 6.22268 6.77728 7.40334C6.68945 7.53221 6.26614 7.98575 5.80539 7.70715C5.22802 7.35871 2.99052 5.76697 1.92217 4.9909L1.20801 5.33934L1.20873 5.34006Z",
    fill: "url(#paint11_linear_3933_15437)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M2.50209 5.18037C2.50209 5.44586 2.39662 5.70048 2.20889 5.88822C2.02116 6.07595 1.76654 6.18142 1.50104 6.18142C1.23555 6.18142 0.980931 6.07595 0.793199 5.88822C0.605467 5.70048 0.5 5.44586 0.5 5.18037C0.5 4.91497 0.605429 4.66045 0.793094 4.47278C0.980758 4.28512 1.23529 4.17969 1.50068 4.17969C1.76608 4.17969 2.02061 4.28512 2.20827 4.47278C2.39594 4.66045 2.50137 4.91497 2.50137 5.18037H2.50209Z",
    fill: "url(#paint12_radial_3933_15437)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M2.50209 5.18037C2.50209 5.44586 2.39662 5.70048 2.20889 5.88822C2.02116 6.07595 1.76654 6.18142 1.50104 6.18142C1.23555 6.18142 0.980931 6.07595 0.793199 5.88822C0.605467 5.70048 0.5 5.44586 0.5 5.18037C0.5 4.91497 0.605429 4.66045 0.793094 4.47278C0.980758 4.28512 1.23529 4.17969 1.50068 4.17969C1.76608 4.17969 2.02061 4.28512 2.20827 4.47278C2.39594 4.66045 2.50137 4.91497 2.50137 5.18037H2.50209Z",
    fill: "url(#paint13_radial_3933_15437)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M2.50209 5.18037C2.50209 5.44586 2.39662 5.70048 2.20889 5.88822C2.02116 6.07595 1.76654 6.18142 1.50104 6.18142C1.23555 6.18142 0.980931 6.07595 0.793199 5.88822C0.605467 5.70048 0.5 5.44586 0.5 5.18037C0.5 4.91497 0.605429 4.66045 0.793094 4.47278C0.980758 4.28512 1.23529 4.17969 1.50068 4.17969C1.76608 4.17969 2.02061 4.28512 2.20827 4.47278C2.39594 4.66045 2.50137 4.91497 2.50137 5.18037H2.50209Z",
    fill: "url(#paint14_radial_3933_15437)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M2.50209 5.18037C2.50209 5.44586 2.39662 5.70048 2.20889 5.88822C2.02116 6.07595 1.76654 6.18142 1.50104 6.18142C1.23555 6.18142 0.980931 6.07595 0.793199 5.88822C0.605467 5.70048 0.5 5.44586 0.5 5.18037C0.5 4.91497 0.605429 4.66045 0.793094 4.47278C0.980758 4.28512 1.23529 4.17969 1.50068 4.17969C1.76608 4.17969 2.02061 4.28512 2.20827 4.47278C2.39594 4.66045 2.50137 4.91497 2.50137 5.18037H2.50209Z",
    fill: "url(#paint15_linear_3933_15437)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M6.35999 5.36022C6.55113 5.24826 6.69971 5.07604 6.78245 4.87056C6.8652 4.66508 6.87742 4.43795 6.81721 4.22477C6.757 4.0116 6.62775 3.82443 6.44974 3.6926C6.27172 3.56077 6.05499 3.49173 5.83353 3.49631C5.61206 3.50088 5.39837 3.57881 5.22595 3.71789C5.05353 3.85696 4.93213 4.04931 4.88078 4.26479C4.82942 4.48027 4.85102 4.7067 4.94218 4.90859C5.03334 5.11047 5.18891 5.27641 5.38451 5.38038C5.48089 5.34327 5.58667 5.33822 5.68615 5.36598C5.84021 5.41062 6.09363 5.46677 6.36071 5.36022H6.35999Z",
    fill: "url(#paint16_radial_3933_15437)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M6.35999 5.36022C6.55113 5.24826 6.69971 5.07604 6.78245 4.87056C6.8652 4.66508 6.87742 4.43795 6.81721 4.22477C6.757 4.0116 6.62775 3.82443 6.44974 3.6926C6.27172 3.56077 6.05499 3.49173 5.83353 3.49631C5.61206 3.50088 5.39837 3.57881 5.22595 3.71789C5.05353 3.85696 4.93213 4.04931 4.88078 4.26479C4.82942 4.48027 4.85102 4.7067 4.94218 4.90859C5.03334 5.11047 5.18891 5.27641 5.38451 5.38038C5.48089 5.34327 5.58667 5.33822 5.68615 5.36598C5.84021 5.41062 6.09363 5.46677 6.36071 5.36022H6.35999Z",
    fill: "url(#paint17_radial_3933_15437)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M6.35999 5.36022C6.55113 5.24826 6.69971 5.07604 6.78245 4.87056C6.8652 4.66508 6.87742 4.43795 6.81721 4.22477C6.757 4.0116 6.62775 3.82443 6.44974 3.6926C6.27172 3.56077 6.05499 3.49173 5.83353 3.49631C5.61206 3.50088 5.39837 3.57881 5.22595 3.71789C5.05353 3.85696 4.93213 4.04931 4.88078 4.26479C4.82942 4.48027 4.85102 4.7067 4.94218 4.90859C5.03334 5.11047 5.18891 5.27641 5.38451 5.38038C5.48089 5.34327 5.58667 5.33822 5.68615 5.36598C5.84021 5.41062 6.09363 5.46677 6.36071 5.36022H6.35999Z",
    fill: "url(#paint18_radial_3933_15437)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M6.35999 5.36022C6.55113 5.24826 6.69971 5.07604 6.78245 4.87056C6.8652 4.66508 6.87742 4.43795 6.81721 4.22477C6.757 4.0116 6.62775 3.82443 6.44974 3.6926C6.27172 3.56077 6.05499 3.49173 5.83353 3.49631C5.61206 3.50088 5.39837 3.57881 5.22595 3.71789C5.05353 3.85696 4.93213 4.04931 4.88078 4.26479C4.82942 4.48027 4.85102 4.7067 4.94218 4.90859C5.03334 5.11047 5.18891 5.27641 5.38451 5.38038C5.48089 5.34327 5.58667 5.33822 5.68615 5.36598C5.84021 5.41062 6.09363 5.46677 6.36071 5.36022H6.35999Z",
    fill: "url(#paint19_linear_3933_15437)"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_i_3933_15437)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.5955 5.36413C14.4043 5.25217 14.2558 5.07995 14.173 4.87446C14.0903 4.66898 14.0781 4.44185 14.1383 4.22868C14.1985 4.01551 14.3277 3.82833 14.5057 3.6965C14.6837 3.56467 14.9005 3.49564 15.1219 3.50021C15.3434 3.50479 15.5571 3.58272 15.7295 3.72179C15.9019 3.86086 16.0233 4.05322 16.0747 4.2687C16.126 4.48418 16.1044 4.7106 16.0133 4.91249C15.9221 5.11438 15.7666 5.28032 15.571 5.38429C15.4746 5.34717 15.3688 5.34212 15.2693 5.36989C15.1153 5.41452 14.8618 5.47068 14.5948 5.36413H14.5955Z",
    fill: "url(#paint20_linear_3933_15437)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5955 5.36413C14.4043 5.25217 14.2558 5.07995 14.173 4.87446C14.0903 4.66898 14.0781 4.44185 14.1383 4.22868C14.1985 4.01551 14.3277 3.82833 14.5057 3.6965C14.6837 3.56467 14.9005 3.49564 15.1219 3.50021C15.3434 3.50479 15.5571 3.58272 15.7295 3.72179C15.9019 3.86086 16.0233 4.05322 16.0747 4.2687C16.126 4.48418 16.1044 4.7106 16.0133 4.91249C15.9221 5.11438 15.7666 5.28032 15.571 5.38429C15.4746 5.34717 15.3688 5.34212 15.2693 5.36989C15.1153 5.41452 14.8618 5.47068 14.5948 5.36413H14.5955Z",
    fill: "url(#paint21_linear_3933_15437)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_f_3933_15437)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.6289 3.32995C10.7535 3.31556 11.0702 3.37963 11.3488 3.75759C11.6282 4.13554 13.3257 6.55446 14.1392 7.71713C14.2969 7.96046 14.7627 8.34489 15.3652 7.93094C15.9685 7.51699 17.9073 6.11315 18.6387 5.62577",
    stroke: "url(#paint22_linear_3933_15437)",
    strokeWidth: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.6289 3.32995C10.7535 3.31556 11.0702 3.37963 11.3488 3.75759C11.6282 4.13554 13.3257 6.55446 14.1392 7.71713C14.2969 7.96046 14.7627 8.34489 15.3652 7.93094C15.9685 7.51699 17.9073 6.11315 18.6387 5.62577",
    stroke: "url(#paint23_radial_3933_15437)",
    strokeWidth: 0.15
  }))), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4743 3.39392C11.1904 3.39392 11.7709 2.81343 11.7709 2.09735C11.7709 1.38128 11.1904 0.800781 10.4743 0.800781C9.75823 0.800781 9.17773 1.38128 9.17773 2.09735C9.17773 2.81343 9.75823 3.39392 10.4743 3.39392Z",
    fill: "url(#paint24_radial_3933_15437)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4743 3.39392C11.1904 3.39392 11.7709 2.81343 11.7709 2.09735C11.7709 1.38128 11.1904 0.800781 10.4743 0.800781C9.75823 0.800781 9.17773 1.38128 9.17773 2.09735C9.17773 2.81343 9.75823 3.39392 10.4743 3.39392Z",
    fill: "url(#paint25_radial_3933_15437)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4743 3.39392C11.1904 3.39392 11.7709 2.81343 11.7709 2.09735C11.7709 1.38128 11.1904 0.800781 10.4743 0.800781C9.75823 0.800781 9.17773 1.38128 9.17773 2.09735C9.17773 2.81343 9.75823 3.39392 10.4743 3.39392Z",
    fill: "url(#paint26_radial_3933_15437)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4743 3.39392C11.1904 3.39392 11.7709 2.81343 11.7709 2.09735C11.7709 1.38128 11.1904 0.800781 10.4743 0.800781C9.75823 0.800781 9.17773 1.38128 9.17773 2.09735C9.17773 2.81343 9.75823 3.39392 10.4743 3.39392Z",
    fill: "url(#paint27_linear_3933_15437)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5001 5.18037C20.5001 5.44586 20.3947 5.70048 20.2069 5.88822C20.0192 6.07595 19.7646 6.18142 19.4991 6.18142C19.2336 6.18142 18.979 6.07595 18.7912 5.88822C18.6035 5.70048 18.498 5.44586 18.498 5.18037C18.498 4.91497 18.6035 4.66045 18.7911 4.47278C18.9788 4.28512 19.2333 4.17969 19.4987 4.17969C19.7641 4.17969 20.0187 4.28512 20.2063 4.47278C20.394 4.66045 20.4994 4.91497 20.4994 5.18037H20.5001Z",
    fill: "url(#paint28_radial_3933_15437)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5001 5.18037C20.5001 5.44586 20.3947 5.70048 20.2069 5.88822C20.0192 6.07595 19.7646 6.18142 19.4991 6.18142C19.2336 6.18142 18.979 6.07595 18.7912 5.88822C18.6035 5.70048 18.498 5.44586 18.498 5.18037C18.498 4.91497 18.6035 4.66045 18.7911 4.47278C18.9788 4.28512 19.2333 4.17969 19.4987 4.17969C19.7641 4.17969 20.0187 4.28512 20.2063 4.47278C20.394 4.66045 20.4994 4.91497 20.4994 5.18037H20.5001Z",
    fill: "url(#paint29_radial_3933_15437)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5001 5.18037C20.5001 5.44586 20.3947 5.70048 20.2069 5.88822C20.0192 6.07595 19.7646 6.18142 19.4991 6.18142C19.2336 6.18142 18.979 6.07595 18.7912 5.88822C18.6035 5.70048 18.498 5.44586 18.498 5.18037C18.498 4.91497 18.6035 4.66045 18.7911 4.47278C18.9788 4.28512 19.2333 4.17969 19.4987 4.17969C19.7641 4.17969 20.0187 4.28512 20.2063 4.47278C20.394 4.66045 20.4994 4.91497 20.4994 5.18037H20.5001Z",
    fill: "url(#paint30_radial_3933_15437)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5001 5.18037C20.5001 5.44586 20.3947 5.70048 20.2069 5.88822C20.0192 6.07595 19.7646 6.18142 19.4991 6.18142C19.2336 6.18142 18.979 6.07595 18.7912 5.88822C18.6035 5.70048 18.498 5.44586 18.498 5.18037C18.498 4.91497 18.6035 4.66045 18.7911 4.47278C18.9788 4.28512 19.2333 4.17969 19.4987 4.17969C19.7641 4.17969 20.0187 4.28512 20.2063 4.47278C20.394 4.66045 20.4994 4.91497 20.4994 5.18037H20.5001Z",
    fill: "url(#paint31_linear_3933_15437)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_ii_3933_15437",
    x: 0.808008,
    y: 2.85312,
    width: 19.3381,
    height: 14.3227,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.4,
    dy: -0.1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.25
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.803922 0 0 0 0 0.580392 0 0 0 0 0.262745 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_3933_15437"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -0.4,
    dy: -0.1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.25
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.894118 0 0 0 0 0.686275 0 0 0 0 0.301961 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_3933_15437",
    result: "effect2_innerShadow_3933_15437"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i_3933_15437",
    x: 14.1006,
    y: 3.5,
    width: 2.00098,
    height: 1.92578,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.125
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.756863 0 0 0 0 0.619608 0 0 0 0 0.321569 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_3933_15437"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_3933_15437",
    x: 10.4701,
    y: 3.10391,
    width: 8.36055,
    height: 5.23359,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.075,
    result: "effect1_foregroundBlur_3933_15437"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_3933_15437",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(5.18974 6.35438) rotate(15.9454) scale(2.29297 5.72315)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBC96E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAC567"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_3933_15437",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(6.53958 6.84896) rotate(-156.753) scale(1.73847 5.22852)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.765,
    stopColor: "#D89F3A",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.911,
    stopColor: "#DAA139"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_3933_15437",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(16.1463 7.7484) rotate(-125.455) scale(1.82284 1.8695)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.254,
    stopColor: "#BF812A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CE9333"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_3933_15437",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(14.7402 6.85976) rotate(-23.0909) scale(1.57747 4.10955)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.734,
    stopColor: "#E9BB61",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.929,
    stopColor: "#E9BB61"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_3933_15437",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(15.6744 7.30954) rotate(-142.922) scale(2.48148 4.18637)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.773,
    stopColor: "#C18739",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.948,
    stopColor: "#C18739"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_3933_15437",
    x1: 15.6654,
    y1: 11.4107,
    x2: 2.94733,
    y2: 14.3768,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFBC5D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.304,
    stopColor: "#FCAD6A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CB7547"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial_3933_15437",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(7.69374 19.5306) rotate(-69.4212) scale(7.92095 15.4167)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F67B4E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F67B4E",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_3933_15437",
    x1: 2.76087,
    y1: 14.069,
    x2: 4.71832,
    y2: 13.6645,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C2794C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E07648",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_3933_15437",
    x1: 10.4769,
    y1: 0.388879,
    x2: 10.4769,
    y2: 19.4492,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FACB30"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.302269,
    stopColor: "#FEF9C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.640625,
    stopColor: "#C49530"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF8C4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_3933_15437",
    x1: 11.5129,
    y1: 17.3763,
    x2: 11.5129,
    y2: 16.5211,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.184,
    stopColor: "#FF6F8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7A6A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint10_radial_3933_15437",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(19.162 5.52004) rotate(113.385) scale(1.81379 1.50349)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.377,
    stopColor: "#DD9049"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F8BF60",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_3933_15437",
    x1: 10.4769,
    y1: 0.388879,
    x2: 10.4769,
    y2: 19.4492,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FACB30"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.302269,
    stopColor: "#FEF9C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.640625,
    stopColor: "#C49530"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF8C4"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint12_radial_3933_15437",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(2.31042 4.49641) rotate(135.198) scale(2.14022 2.22661)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.172,
    stopColor: "#E7C04E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9972A"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint13_radial_3933_15437",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1.27594 6.3122) rotate(-71.331) scale(1.19477 1.29421)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.065,
    stopColor: "#DF8089"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DF8089",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint14_radial_3933_15437",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(2.3905 4.54253) rotate(141.017) scale(1.01296 0.523472)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDE71"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFDE71",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_3933_15437",
    x1: 1.50104,
    y1: 3.81938,
    x2: 1.50104,
    y2: 6.50169,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FACB30"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.302269,
    stopColor: "#FEF9C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.640625,
    stopColor: "#C49530"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF8C4"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint16_radial_3933_15437",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(6.6643 3.79988) rotate(136.302) scale(2.10041 2.18298)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.172,
    stopColor: "#E7C04E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9972A"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint17_radial_3933_15437",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(6.74299 3.8448) rotate(142.093) scale(0.997979 0.511239)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDE71"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFDE71",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint18_radial_3933_15437",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(5.85461 5.54308) rotate(-76.7987) scale(0.935879 1.24819)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4A122"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E4A122",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_3933_15437",
    x1: 5.8542,
    y1: 3.14956,
    x2: 5.8542,
    y2: 5.72931,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FACB30"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.302269,
    stopColor: "#FEF9C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.640625,
    stopColor: "#C49530"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF8C4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_3933_15437",
    x1: 15.1013,
    y1: 3.15347,
    x2: 15.1013,
    y2: 5.73322,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FACB30"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.302269,
    stopColor: "#FEF9C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.640625,
    stopColor: "#C49530"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF8C4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_3933_15437",
    x1: 15.1013,
    y1: 3.15347,
    x2: 15.1013,
    y2: 5.73322,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FACB30"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.302269,
    stopColor: "#FEF9C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.640625,
    stopColor: "#C49530"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF8C4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_3933_15437",
    x1: 10.6296,
    y1: 3.18453,
    x2: 15.1968,
    y2: 8.94386,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD678"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD678",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint23_radial_3933_15437",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(15.1968 8.38161) rotate(-34.6679) scale(4.67748 1.25282)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.289,
    stopColor: "#FFD175"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD175",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint24_radial_3933_15437",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(11.5129 1.38311) rotate(125.606) scale(2.47306 2.09969)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.376,
    stopColor: "#F3D154"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CC9848"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint25_radial_3933_15437",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(10.2295 3.39392) rotate(-79.3129) scale(1.31929 1.56827)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E78F5E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E78F5E",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint26_radial_3933_15437",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(11.0171 2.53074) rotate(-146.725) scale(2.58329 3.08973)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.557,
    stopColor: "#E9C251",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B49858"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_3933_15437",
    x1: 10.4743,
    y1: 0.334016,
    x2: 10.4743,
    y2: 3.80882,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FACB30"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.302269,
    stopColor: "#FEF9C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.640625,
    stopColor: "#C49530"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF8C4"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint28_radial_3933_15437",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(20.3088 4.49716) rotate(135.198) scale(2.14022 2.22661)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.172,
    stopColor: "#F8CB54"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EAA34B"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint29_radial_3933_15437",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(19.2741 6.31208) rotate(-71.3304) scale(1.19476 1.61496)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#F1907C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F1907C",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint30_radial_3933_15437",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(20.3893 4.54325) rotate(141.017) scale(1.01297 0.523472)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDE71"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFDE71",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_3933_15437",
    x1: 19.4991,
    y1: 3.81938,
    x2: 19.4991,
    y2: 6.50169,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FACB30"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.302269,
    stopColor: "#FEF9C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.640625,
    stopColor: "#C49530"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF8C4"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon20);
export default __webpack_public_path__ + "static/media/icon20.c8a5bfe8b7379d077e5e7bce22206ac1.svg";
export { ForwardRef as ReactComponent };